import { create } from 'zustand';

interface FreeLoginStore {
  failedLoginAttempt: number;
  isBlocked: boolean;

  incrementFailedLoginAttempt: () => void;
  resetFailedLoginAttempt: () => void;

  setBlocked: (isBlocked: boolean) => void;
}

export const useFreeLogin = create<FreeLoginStore>()(set => ({
  failedLoginAttempt: 0,
  isBlocked: false,

  incrementFailedLoginAttempt: () =>
    set(state => ({ failedLoginAttempt: state.failedLoginAttempt + 1 })),

  resetFailedLoginAttempt: () => set({ failedLoginAttempt: 0 }),

  setBlocked: isBlocked => set({ isBlocked }),
}));
